import styled from "styled-components";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { Icon } from "@sablier/v2-components/molecules";
import { useFT, useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { Empty as Base } from "~/client/components/atoms";

const Wrapper = styled(Base)``;
interface Props {
  content?: string;
  isSaveSuggested?: boolean;
  onSuggest?: () => void;
}

export default function Empty({
  content: _content,
  isSaveSuggested = false,
  onSuggest,
}: Props) {
  const { t } = useT();
  const content = useFT(_content, "structs.noAssetsFound");
  return (
    <Wrapper>
      {content}
      {isSaveSuggested && (
        <>
          {" "}
          <span onClick={onSuggest}>
            <b>
              {_.capitalize(t("words.search"))}{" "}
              <Icon value={MagnifyingGlassIcon} size={18} thickness={2.8} />
            </b>{" "}
            {t("structs.forCustomTokens")}.
          </span>
        </>
      )}
    </Wrapper>
  );
}
